import { createReducer } from 'shared';
import { fetchApplications } from 'redux/actions';

export const applicationsEntitiesReducer = createReducer(
  {},
  {
    [fetchApplications]: (entities, action) => ({ ...entities, ...action.entities }),
  }
);
